import {
  MIDFEED_PRIMARY_FOCUS_DEFAULT_BOOST,
  PRIMARY_FOCUS_MIDFEED_BOOST_DEFAULT_MAP
} from './constants'

export const sortAndBoostAdsByPrimaryFocus = (centers, primaryFocus) => {
  return centers
    .map((center) => {
      return {
        ...center,
        primaryFocusBoost: center.primaryFocus.includes(primaryFocus)
          ? PRIMARY_FOCUS_MIDFEED_BOOST_DEFAULT_MAP[primaryFocus]
          : 0
      }
    })
    .sort((a, b) => {
      // Make priority negative so that higher priority ads are sorted first
      const score = {
        a: a.priority + a.pacing + Math.random() + a.primaryFocusBoost,
        b: b.priority + b.pacing + Math.random() + b.primaryFocusBoost
      }
      return score.b - score.a
    })
}
